// extracted by mini-css-extract-plugin
export default {"sizer":"sizer___d1d556d898c51f607070"};